<template>
  <footer class="the-footer">
    <div class="title">
      <img
        src="https://d33wubrfki0l68.cloudfront.net/161385efe91e42c1d9b20d12c388b16e59d32b9f/883d9/img/logo_white.png"
        alt="ロゴ"
      />
      <p>【公式】ロイヤルハニーV購入サイト</p>
    </div>
    <p class="copy">HONEY LAB. © 2019</p>
  </footer>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.the-footer {
  box-sizing: border-box;
  color: #fff;
  background: #1c1c3e;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
  height: 280px;

  > .copy {
    font-size: 0.75em;
    font-weight: bold;
  }

  > .title {
    > img {
      width: 216px;
    }

    > p {
      margin-top: 16px;
      font-size: 0.75em;
    }
  }
}
</style>
